import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_2 = { class: "isAgree" }
const _hoisted_3 = { class: "btns" }

import { useUsersStore } from '@/pinia'
import { Get, Post } from '@/utils/api'
import { ElMessage } from 'element-plus'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'customized',
  setup(__props) {

const store = useUsersStore()
const { t } = useI18n()
const Router = useRouter()

const List = ref([])
const BasicDictionaryList = ref([])
const StatuId = ref(null)
const selected = ref(null)
const isAgree = ref(false)
const isLoading = ref(false)
const IsVerifys = ref(false)
const StatuName = ref(null)

const closeService = () => {
  isLoading.value = true
  Post('user/api/CustomerDistributionService/', {
    ApiName: 'api/CustomerDistributionService/',
    TypeId: 2,
  }).then((res: any): any => {
    isLoading.value = false
    store.upDateuserCenter = !store.upDateuserCenter
    getStatus()
    ElMessage({
      message: t('已保存'),
      type: 'success',
    })
  })
}

const setValue = (itme) => {
  if (!itme.IsVerify) {
    switch (itme.TypeId) {
      case 1:
        Router.push('/userCenter/settings')
        break
      case 3:
        Router.push('/userCenter/addressList')
        break
      case 5:
        Router.push('/userCenter/repository')
        break
    }
  }
}

const submit = () => {
  isLoading.value = true
  Post('user/api/CustomerDistributionService/', {
    ApiName: 'api/CustomerDistributionService/',
    TypeId: StatuId.value == 3 ? 1 : 3,
    DeliveryServiceTypeId: selected.value,
  }).then((res: any): any => {
    isLoading.value = false
    getStatus()
    store.upDateuserCenter = !store.upDateuserCenter
    ElMessage({
      message: t('已保存'),
      type: 'success',
    })
  })
}
const getStatus = () => {
  Get('user/api/GetCustomerDistributionService/', {}).then((res: any) => {
    StatuId.value = res.StatuId
    selected.value = res.StatuId == 3 ? null : res.DeliveryServiceTypeId
    StatuName.value = res.StatuName
  })
}

onMounted(() => {
  Get('user/api/CustomerDistributionService/', {}).then((res: any) => {
    List.value = res.List
    IsVerifys.value = List.value.every((e) => e.IsVerify)
  })
  Get('basic/api/BasicDictionary', { type_id: 96 }).then((res: any) => {
    BasicDictionaryList.value = res.BasicDictionaryList
  })
  getStatus()
})

return (_ctx: any,_cache: any) => {
  const _component_Check = _resolveComponent("Check")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(List.value, (item) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          key: item,
          class: "cardItem",
          onClick: ($event: any) => (setValue(item))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", null, _toDisplayString(item.TypeName), 1),
              _createElementVNode("p", null, _toDisplayString(item.TypeValue || item.VerifyMsg), 1)
            ]),
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                (item.IsVerify)
                  ? (_openBlock(), _createBlock(_component_Check, {
                      key: 0,
                      class: "Check"
                    }))
                  : (_openBlock(), _createBlock(_component_Edit, {
                      key: 1,
                      class: "Edit"
                    }))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128)),
      _createVNode(_component_el_card, { class: "cardItem" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('配送服务')) + "-(" + _toDisplayString(StatuName.value) + ")", 1),
            _createElementVNode("p", null, [
              _createVNode(_component_el_select, {
                modelValue: selected.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
                placeholder: _ctx.$t('请选择')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(BasicDictionaryList.value, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.DicValue
                    }, [
                      (item.DicValue !== 5)
                        ? (_openBlock(), _createBlock(_component_el_option, {
                            key: 0,
                            label: item.DicName,
                            value: item.DicValue
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(item.DicName), 1),
                              _createElementVNode("sub", null, "(" + _toDisplayString(item.Desc) + ")", 1),
                              (item.DicValue == 2)
                                ? (_openBlock(), _createElementBlock("sub", _hoisted_1, " (" + _toDisplayString(_ctx.$t('付费服务')) + ") ", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Edit, { class: "Edit" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_checkbox, {
          modelValue: isAgree.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isAgree).value = $event)),
          size: "large"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('我已同意并阅读')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_router_link, { to: { path: '/article', query: { Id: 9 } } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('定制配送服务条款及协议')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (submit())),
          type: "danger",
          disabled: !isAgree.value || !selected.value || !IsVerifys.value,
          loading: isLoading.value,
          size: "large"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(StatuId.value === 5 ? '修改' : '开通')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"]),
        (StatuId.value === 5)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (closeService())),
              loading: isLoading.value,
              size: "large"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('关闭')), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})